const { registerBlockType } = wp.blocks;

import attributes from './attributes';
import Edit from './edit';

registerBlockType('app/list-cities', {
  title: 'List Cities Server Side',
  description: 'Retorna a lista de cidades do Assine',
  icon: 'list-view',
  category: 'design',
  parent: ['app/locate-selector'],
  attributes,

  edit: (props) => <Edit {...props} />,
  save: function () {
    return <div></div>;
  },
});
